import { AppAreaConfig } from '@/funnels/@types'
import maleTaiChiWalking from './activity-male-tai-chi-walking'
import femaleTaiChiWalkingV2 from './activity-female-tai-chi-walking-v2'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-tai-chi-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking', 'age-tai-chi-walking'],
		route: {
			path: '/tai-chi-walking',
			name: 'main-tai-chi-walking-funnel',
		},
		overrides: [
			{
				matcher: {
					$and: {
						utm_campaign: /search/,
						utm_content: /taichiwalkinggs/,
					},
				},
				ids: ['creatives-search-tai-chi-walking-gs', 'age-tai-chi-walking'],
			},
		],
	},
	funnel: {
		id: 'ob-tai-chi-walking-gender-selection',
		route: {
			path: '/tai-chi-walking/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'tai-chi-walking-survey',
		},
		slug: 'main-tai-chi-walking',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: maleTaiChiWalking },
				female: { appArea: femaleTaiChiWalkingV2 },
			},
		},
	},
}

export default appAreaConfig
